import { useGetModelPoIsQuery } from "generated/graphql";
import { useCluster } from "in_queue/contexts/ClusterContext";
import {
    convertHasuraModelPOIstoModelPOIs,
    ModelPOI,
    POIType
} from "in_queue/types/modelPOI";
import { useEffect, useState } from "react";

export const useModelPOIs = ({
    poiQuery,
    poiType
}: {
    poiQuery: string;
    poiType: POIType;
}) => {
    const [modelPOIs, setModelPOIs] = useState<ModelPOI[]>([]);

    const cluster = useCluster();

    // this query retrieves possible POIs based on the user query
    const { data: hasuraModelPOIs, loading: modelPOIsLoading } =
        useGetModelPoIsQuery({
            variables: {
                poiName: `%${poiQuery}%`,
                poi: `%${poiQuery}%`,
                poiType: poiType,
                clusterId: cluster.id
            },
            skip: !poiQuery || poiQuery.length === 0
        });

    useEffect(() => {
        if (!modelPOIsLoading && hasuraModelPOIs) {
            const modelPOIs = convertHasuraModelPOIstoModelPOIs(
                hasuraModelPOIs,
                cluster
            );
            setModelPOIs(modelPOIs);
        } else if (!poiQuery) {
            setModelPOIs([]);
        }
    }, [hasuraModelPOIs, modelPOIsLoading, poiQuery, cluster]);

    return modelPOIs;
};
